import { IonHeader, IonToolbar, IonTitle, IonButtons, useIonViewWillEnter } from '@ionic/react';
import React from 'react';
import './Header.css';
import MenuButton from './MenuButton';
import { StatusBar } from '@capacitor/status-bar';
import { Capacitor } from '@capacitor/core';

interface ContainerProps {
    pageName: string;
}

const Header: React.FC<ContainerProps> = ({ pageName }) => {

    // Este bloque se ejecutará cada vez que una página con este header se vaya a mostrar
    useIonViewWillEnter(() => {
        const setStatusBarColor = async () => {
            // Solo se ejecuta en la app móvil
            if (Capacitor.isNativePlatform()) {
                // Establece el color de la barra de estado para que coincida con este header
                await StatusBar.setBackgroundColor({ color: '#010199' });
            }
        };
        setStatusBarColor();
    });

    return (
        <IonHeader mode="ios" className="header-blue ion-no-border">
            <IonToolbar className="header-page header-background-color">
                <IonButtons slot="start">
                    <MenuButton />
                </IonButtons>
                
                <IonTitle>
                    {pageName}
                </IonTitle>
            </IonToolbar>
        </IonHeader>
    );
}

export default Header;